<template>
  <form class="loginForm" @keyup.enter="handleLogin">
    <FormInput type="text" :maxlength="11" autocomplete="on" name="telephone" v-model="form.telephone" placeholder="请输入登录手机号" :isShowPrefix="true" @changeCountry="changeCountry" @changeDeafultCountry="changeDeafultCountry"></FormInput>
    <input type="password" style="display:none" />
    <!-- <FormSMSInput mt="30px" :maxlength="6" :type="1" autocomplete="on" :telephone="form.telephone" v-model="form.code" placeholder="请输入验证码"></FormSMSInput> -->
    <FormSMSInput ref="smsInput" @captcha="handleCaptcha" mt="30px" :isCaptcha="false" :maxlength="6" :type="1" autocomplete="on" :telephone="form.telephone" v-model="form.code" placeholder="请输入验证码"></FormSMSInput>
    <!-- <NoCaptcha ref="captcha" @timeDown="handleTimeDown"/> -->
    <FormButton mt="73px" height="55px" @click="handleLogin" :disabled="!isFormValid">登录</FormButton>
    <div class="liveOutInforContainer">
      <!-- <p class="liveOutInfor" @click="handleGoLive">直播云登录已迁移，点击登录</p> -->
    </div>
  </form>
</template>

<script>
import Cookies from 'js-cookie'
import authApi from '@/services/auth/index'
import { removePermissions } from '@/services/utils'
import { validForm, validTelephone } from '@/utils/validators'
import { mapActions, mapGetters } from 'vuex'
import { WE_MAIN_URL } from '@/config'
// import NoCaptcha from '@/components/NoCaptcha'
import { GetQueryValue, getCountryNameZh } from '@/utils/index'
import commonLink from '@/utils/commonLink'
import sendSensors from '@/mixins/sendSensors.js'
import loginMixin from './mixin'

export default {
  mixins: [sendSensors, loginMixin],
  props: {
    lastUser: {
      type: Object
    },
    checkedAgreement: false
  },
  data () {
    return {
      form: {
        telephone: '',
        code: '',
        type: 2, // for PC
        country_id: 44
      }
    }
  },
  computed: {
    isFormValid () {
      return validForm(this.form)
    },
    ...mapGetters(['workCountryData'])
  },
  components: {
    // NoCaptcha
  },
  methods: {
    ...mapActions(['queryAdverse']),
    handleCaptcha (params) {
      if (this.form.country_id !== 44) {
        this.$toast.danger('验证码登录仅支持中国大陆地区手机号使用，其他国际地区暂不可使用')
      } else if (!validTelephone(this.form.telephone)) {
        this.$toast.warning('手机号不合法')
      } else {
        params.country_id = this.form.country_id
        // this.$refs.captcha.handleCaptcha(params)
      }
    },
    handleTimeDown () {
      this.$refs.smsInput.startCountdown()
    },

    handleLogin () {
      if (this.form.country_id !== 44) {
        return this.$toast.danger('验证码登录仅支持中国大陆地区手机号使用，其他国际地区暂不可使用')
      }
      if (!validTelephone(this.form.telephone)) {
        return this.$toast.warning('手机号不合法')
      }
      if (!this.isFormValid) {
        return this.$toast.warning('表单填写有误')
      }
      if (!this.checkedAgreement) {
        return this.$toast.warning('请先阅读并勾选同意《用户协议》与《隐私政策》')
      }
      authApi.smsAuth({
        telephone: this.form.telephone,
        code: this.form.code
      }).then(res => {
        if (res.ok) {
          if (res.data) {
            this.dealStuLogin(res.data)
          }
        }
      })
    },
    isGoJiaowu (role) {
      if (role === '前台') {
        // 前台跳学校管理
        return true
      } else if (role.split(',').indexOf('前台') >= 0 && role.split(',').indexOf('辅导老师') >= 0 && role.split(',').length === 2) {
        // 前台+辅导老师跳学校管理
        return true
      } else if (role.split(',').indexOf('前台') >= 0 && role.split(',').indexOf('教师') >= 0 && role.split(',').length === 2) {
        // 前台+辅导老师跳学校管理
        return true
      } else if (role.split(',').indexOf('招生') >= 0 && role.split(',').indexOf('教师') >= 0 && role.split(',').length === 2) {
        // 前台+辅导老师跳学校管理
        return true
      } else if (role.split(',').indexOf('前台') >= 0 && role.split(',').indexOf('招生') >= 0 && role.split(',').indexOf('教师') >= 0 && role.split(',').length === 3) {
        // 前台+辅导老师跳学校管理
        return true
      } else if (role === '辅导老师' || role === '老师') {
        // 只有辅导老师跳主站
        return false
      } else if (role === '招生') {
        // 只有辅导老师跳主站
        return true
      } else if (role.split(',').indexOf('前台') >= 0 && role.split(',').indexOf('老师') >= 0 && role.split(',').length === 2) {
        // 前台+辅导老师跳学校管理
        return true
      } else {
        // 辅导+其他，前台+其他，面授（直播）主讲+其他跳主站
        return false
      }
    },
    handleGoLive () {
      window.location.href = WE_MAIN_URL + '/liveAuth'
    },
    initOfficialTel (tel) {
      console.log('initOfficialTel', tel)
      this.form.telephone = tel
    },
    changeCountry (val) {
      this.form.country_id = val
      let name_zh = getCountryNameZh(this.workCountryData, this.form.country_id)
      this.sendSensors('Abroad_number', { 'Verification_code_login': name_zh })
    },
    // 修改默认区号
    changeDeafultCountry (val) {
      this.form.country_id = val
    }
  },
  created () {
    if (this.lastUser) {
      this.form.telephone = this.lastUser.telephone
    }
    this.form.code = ''
    if (GetQueryValue('officialTel')) {
      let tel = GetQueryValue('officialTel')
      this.initOfficialTel(tel)
    }
  }
}
</script>

<style scoped lang="scss">
.loginForm {
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
  width: 380px;
  .liveOutInforContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .liveOutInfor {
      user-select: none;
      color: crimson;
      font-size: 14px;
      font-weight: 700;
      width: fit-content;
      text-align: right;
      margin: 10px 0 0 0;
      cursor: pointer;
    }
  }
  /deep/ .form-control {
    height: 55px;
    padding: 0 20px;
    font-size: 16px;
    color: #202428;
    background: #F9FBFC;
  }
  /deep/ .FormInput .close, /deep/ .FormInput .input-group-addon {
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }
  /deep/ .FormInput .hasEyeClose {
    right: 40px;
  }
  /deep/ .phone-prefix-select {
    height: 55px;
    width: 80px;
    top: 0;
    left: 0;
  }
  /deep/ .el-input--suffix {
    height: 100%;
  }
  /deep/ .el-select-dropdown {
    width: 380px!important;
  }
  /deep/ input:-internal-autofill-selected {
    background-color: #F9FBFC!important;
  }
  /deep/ .FormInput input, /deep/ .FormSMSInput input {
    border-bottom: none;
  }
  /deep/ input:-webkit-autofill {
    background-color: #F9FBFC!important;
    box-shadow: inset 0 0 0 1000px #F9FBFC!important;
    -webkit-box-shadow: inset 0 0 0 1000px #F9FBFC!important;
  }
  /deep/ input {  filter: none !important;  }
  /deep/ input:-webkit-autofill:focus {
    background: #F9FBFC!important;
  }
  /deep/ .FormSMSInput .smsBtn {
    right: 20px;
    bottom: 14px;
    color: #2D5BFF;
  }
  /deep/ .FormSMSInput .countdownMsg {
    right: 20px;
    bottom: 14px;
    color: #8E9DAE;
  }
  /deep/ .close {
    span {
      display: none;
    }
    &:after {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(../../assets/icons/input_close_icon.png);
      background-size: 16px 16px;
    }
  }
  // /deep/ .FormButton {
  //   // font-family: PingFangSC-Medium,PingFang SC;
  //   font-weight: 500;
  //   border-radius: 3px;
  // }
}

.forgetRow {
  text-align: right;
  margin-top: -20px;
  margin-bottom: 16px;
}

.tip {
  margin-top: 10px;
  text-align: center;
  color: #3a9cff;
  font-size: 14px;
}
/deep/ input::-webkit-input-placeholder {
  font-size: 16px;
  color: #BEC9D0;
}
/deep/ input::-moz-input-placeholder {
  font-size: 16px;
  color: #BEC9D0;
}
/deep/ input::-ms-input-placeholder {
  font-size: 16px;
  color: #BEC9D0;
}
</style>
